import component from "./BitcoinPaymentForm.vue";
import { cryptoButton, cryptoPageTitle, systemName } from "./config";

export default {
  component,
  cryptoPageTitle,
  cryptoButton,
};

export const selector = (cryptoPaymentSystem: string | null): boolean => {
  return cryptoPaymentSystem === systemName;
};
